/* TET smart search: drawer under the TET header with live predictive results */
(function () {
  if (customElements.get('tet-smart-search')) return;

  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var highlight = function (text, q) {
    var safe = esc(text);
    var terms = q.trim().split(/\s+/).filter(function (t) { return t.length > 1; })
      .map(function (t) { return esc(t).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
    if (!terms.length) return safe;
    return safe.replace(new RegExp('(' + terms.join('|') + ')', 'gi'), '<mark>$1</mark>');
  };
  var sized = function (url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  };

  /* Move the toggles and drawer into the custom TET header (#tet-nav). */
  var mount = function () {
    var nav = document.getElementById('tet-nav');
    var drawer = document.getElementById('tn-search');
    var holder = document.querySelector('.tn-ss-mount');
    if (!nav || !drawer || !holder) return;
    var desk = holder.querySelector('.tn-search-toggle--desktop');
    var mob = holder.querySelector('.tn-search-toggle--mobile');
    var right = nav.querySelector('.tn-nav-right');
    var cafe = right && right.querySelector('.tn-cafe-btn');
    if (right && desk) right.insertBefore(desk, cafe || right.firstChild);
    var inner = nav.querySelector('.tn-mainbar-inner');
    if (inner && mob) inner.appendChild(mob);
    var bar = nav.querySelector('.tn-mainbar');
    if (bar) bar.parentNode.insertBefore(drawer, bar.nextSibling);
  };
  mount();
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.tn-ss-mount')) window.location.reload();
  });

  class TetSmartSearch extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.drawer = this.closest('.tn-search');
      this.input = this.querySelector('.tet-ss__input');
      this.form = this.querySelector('form');
      this.panel = this.querySelector('.tet-ss__panel');
      this.idle = this.querySelector('[data-ss-idle]');
      this.results = this.querySelector('[data-ss-results]');
      this.status = this.querySelector('[data-ss-status]');
      this.clearBtn = this.querySelector('.tet-ss__clear');
      this.toggles = Array.prototype.slice.call(document.querySelectorAll('[data-ss-toggle]'));
      this.cache = {};
      this.timer = null;
      this.controller = null;
      try {
        this.money = new Intl.NumberFormat('en-US', { style: 'currency', currency: this.dataset.currency || 'USD' });
      } catch (e) {
        this.money = { format: function (n) { return '$' + Number(n).toFixed(2); } };
      }

      this.toggles.forEach((t) => t.addEventListener('click', () => (this.isOpen() ? this.closeDrawer(true) : this.openDrawer())));
      this.querySelector('[data-ss-close]').addEventListener('click', () => this.closeDrawer(true));
      this.input.addEventListener('input', () => this.onInput());
      this.input.addEventListener('keydown', (e) => this.onKey(e));
      this.clearBtn.addEventListener('click', () => { this.input.value = ''; this.onInput(); this.input.focus(); });
      this.form.addEventListener('submit', (e) => {
        var sel = this.selected();
        if (sel) { e.preventDefault(); sel.click(); }
        else if (!this.input.value.trim()) e.preventDefault();
      });
      document.addEventListener('keydown', (e) => {
        var tag = (document.activeElement && document.activeElement.tagName) || '';
        if (e.key === '/' && !/input|textarea|select/i.test(tag) && !document.activeElement.isContentEditable) { e.preventDefault(); this.openDrawer(); }
        else if (e.key === 'Escape' && this.isOpen()) this.closeDrawer(true);
      });
      document.addEventListener('click', (e) => {
        if (!this.isOpen()) return;
        if (this.drawer.contains(e.target) || this.toggles.some(function (t) { return t.contains(e.target); })) return;
        this.closeDrawer(false);
      });
      if (this.input.value.trim()) { this.clearBtn.hidden = false; }
    }

    isOpen() { return this.drawer && !this.drawer.hidden; }

    openDrawer() {
      if (!this.drawer) return;
      this.drawer.hidden = false;
      this.toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
      this.input.setAttribute('aria-expanded', 'true');
      var mobileMenu = document.getElementById('tn-mobile');
      if (mobileMenu) mobileMenu.classList.remove('tn-open');
      this.showState();
      if (this.input.value.trim() && !this.results.innerHTML) this.fetchResults(this.input.value.trim());
      setTimeout(() => { this.input.focus(); this.input.select(); }, 30);
    }

    closeDrawer(returnFocus) {
      if (!this.drawer) return;
      this.drawer.hidden = true;
      this.toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      this.input.setAttribute('aria-expanded', 'false');
      this.deselect();
      if (document.activeElement && this.contains(document.activeElement)) document.activeElement.blur();
      if (returnFocus) {
        var visible = this.toggles.filter(function (t) { return t.offsetParent !== null; })[0];
        if (visible) visible.focus();
      }
    }

    showState() {
      var hasQuery = this.input.value.trim().length > 0;
      this.idle.hidden = hasQuery;
      this.results.hidden = !hasQuery;
    }

    onInput() {
      var q = this.input.value.trim();
      this.clearBtn.hidden = !q;
      clearTimeout(this.timer);
      if (!q) { this.results.innerHTML = ''; this.showState(); return; }
      this.timer = setTimeout(() => this.fetchResults(q), 180);
    }

    fetchResults(q) {
      if (this.cache[q]) { this.render(q, this.cache[q]); return; }
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      this.setAttribute('loading', '');
      var params = new URLSearchParams({
        q: q,
        'resources[type]': 'product,collection,page,query',
        'resources[limit]': '8',
        'resources[limit_scope]': 'each',
        'resources[options][unavailable_products]': 'last',
        'resources[options][fields]': 'title,product_type,variants.title,vendor,tag'
      });
      fetch(this.dataset.suggestUrl + '?' + params.toString(), { signal: this.controller.signal, headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
        .then((json) => {
          var res = (json && json.resources && json.resources.results) || {};
          this.cache[q] = res;
          if (this.input.value.trim() === q) this.render(q, res);
        })
        .catch((err) => {
          if (err && err.name === 'AbortError') return;
          this.results.innerHTML = '<p class="tet-ss__empty">Live results are unavailable right now. Press Enter to search.</p>';
          this.showState();
        })
        .finally(() => this.removeAttribute('loading'));
    }

    render(q, res) {
      var products = res.products || [];
      var collections = (res.collections || []).slice(0, 5);
      var pages = (res.pages || []).slice(0, 4);
      var queries = (res.queries || []).filter(function (s) { return s.text && s.text.toLowerCase() !== q.toLowerCase(); }).slice(0, 5);
      var searchUrl = this.dataset.searchUrl + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
      var money = this.money;
      var html;

      if (!products.length && !collections.length && !pages.length && !queries.length) {
        html = '<p class="tet-ss__empty">No matches for &ldquo;' + esc(q) + '&rdquo;. Try a producer, a style like &ldquo;pinot&rdquo; or &ldquo;IPA&rdquo;, or a cheese type.</p>';
        this.status.textContent = 'No results';
      } else {
        var left = '';
        var group = function (title, items, label) {
          if (!items.length) return '';
          return '<div class="tet-ss__group"><p class="tet-ss__heading">' + title + '</p><ul class="tet-ss__list">' +
            items.map(function (it) { return '<li><a class="tet-ss__link" role="option" href="' + esc(it.url) + '">' + highlight(label(it), q) + '</a></li>'; }).join('') +
            '</ul></div>';
        };
        left += group('Suggestions', queries, function (s) { return s.text; });
        left += group('Collections', collections, function (c) { return c.title; });
        left += group('Pages', pages, function (p) { return p.title; });

        var right = '';
        if (products.length) {
          right = '<div class="tet-ss__group"><p class="tet-ss__heading">Products</p><ul class="tet-ss__plist">' +
            products.map(function (p) {
              var img = (p.featured_image && p.featured_image.url) || p.image || '';
              var vendor = String(p.vendor || '').replace(/^The Epicurean Trader,\s*/, '');
              if (vendor === 'The Epicurean Trader') vendor = '';
              var title = String(p.title || '');
              if (vendor && title.indexOf(vendor + ' - ') === 0) title = title.slice(vendor.length + 3);
              var price = p.price !== undefined && p.price !== null && p.price !== '' ? money.format(Number(p.price)) : '';
              return '<li><a class="tet-ss__product" role="option" href="' + esc(p.url) + '">' +
                (img ? '<img class="tet-ss__thumb" src="' + esc(sized(img, 160)) + '" alt="" loading="lazy" width="60" height="60">' : '<span class="tet-ss__thumb"></span>') +
                '<span>' + (vendor ? '<span class="tet-ss__vendor">' + esc(vendor) + '</span>' : '') +
                '<span class="tet-ss__ptitle">' + highlight(title, q) + '</span></span>' +
                '<span class="tet-ss__price">' + esc(price) + (p.available === false ? '<span class="tet-ss__soldout">Sold out</span>' : '') + '</span>' +
                '</a></li>';
            }).join('') + '</ul></div>';
        }
        html = '<div class="tet-ss__cols' + (left && right ? '' : ' tet-ss__cols--single') + '">' +
          (left ? '<div>' + left + '</div>' : '') + (right ? '<div>' + right + '</div>' : '') + '</div>';
        this.status.textContent = products.length + (products.length === 1 ? ' product' : ' products') + ' found';
      }
      html += '<a class="tet-ss__all" role="option" href="' + esc(searchUrl) + '">See all results for &ldquo;' + esc(q) + '&rdquo;</a>';
      this.results.innerHTML = html;
      this.showState();
    }

    options() { return Array.prototype.slice.call(this.panel.querySelectorAll('[role="option"]')).filter(function (el) { return el.offsetParent !== null; }); }
    selected() { return this.panel.querySelector('[aria-selected="true"]'); }
    deselect() { var s = this.selected(); if (s) s.removeAttribute('aria-selected'); }

    onKey(e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      e.preventDefault();
      var opts = this.options();
      if (!opts.length) return;
      var cur = opts.indexOf(this.selected());
      var next = e.key === 'ArrowDown' ? (cur + 1) % opts.length : (cur <= 0 ? opts.length - 1 : cur - 1);
      this.deselect();
      opts[next].setAttribute('aria-selected', 'true');
      if (opts[next].scrollIntoView) opts[next].scrollIntoView({ block: 'nearest' });
    }
  }

  customElements.define('tet-smart-search', TetSmartSearch);
})();
